module.exports = __webpack_public_path__ + "static/media/settings-active.68adb556.svg";